/***************************************************************
Hawaiian Macadamia Nut Services
12/08/2022
Alexander Self
** Large update from prior form: Allows user to submit multiple 
fields in one submission
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with 
recently submitted logs
***************************************************************/
import MechanicalHarvestDisplay2 from './mechHarvest_display_2';
import MechHarvestTable from './mechHarvest_table';
import React from 'react';
const $ = window.$;

const MechHarvestModal2 = ({ 
  id, 
  harvest, 
  previousHarvest, 
  fields,
  employees, 
  onClick 
}) => {
  $(document).ready(() => {
    $(`#${id}`).modal();
  });

  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Mechanical Harvest Log</h4> <hr />
        <div className="row">
          { previousHarvest.length > 0 ?
            <div>
              <span className="flow-text pt-2">
                Recent Records for: <b>{ harvest && harvest.map((h) => `| ${h.field} `)} --- Round { harvest.length > 0 && harvest[0].round }</b>
              </span>
              {
                previousHarvest.map((h) => {
                  const field = fields.find((f) => f.field === h.field)
                  return (
                    <div key={h.field}>
                      {
                        h.previousHarvest.length > 0 ?
                        <div>
                          <h4>{ h.field }</h4>
                          <MechHarvestTable 
                            harvest={h.previousHarvest} 
                            field={field} 
                            totals={true}
                            onClick={() => console.log('Clicked!')} 
                          />
                        </div>
                        : <p>There are no previous records for {h.field} during round { harvest.length > 0 && harvest[0].round }</p>
                      }
                      
                    </div>
                  )
                })
              }
              
            </div>
            : ''
          }
        </div>
        <div className="row">
          <span className="flow-text blue-text">Review & Submit</span><hr />
          <MechanicalHarvestDisplay2 
            harvest={harvest}
            employees={employees} 
          />
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect waves-red btn-flat">Cancel</button>
        <button className="modal-action modal-close waves-effect waves-green btn-flat"
          id="mech-harvest-create-btn"
          onClick={() => onClick(harvest, previousHarvest)}>
          Submit
        </button>
        </div>
    </div>
  );
};

export default MechHarvestModal2;



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_modal_2.jsx